import type { BrandSpecial } from '@iheartjane/data-access';
import type { BrandSpecialUserSegmentIds } from '@iheartjane/types';
import { useMemo } from 'react';

import { useJaneUser } from '@jane/shared/data-access';
/* eslint-disable-next-line no-restricted-imports */
import type { PendingCartProduct } from '@jane/shared/models';
import { brandSpecialOrProductHasSegments } from '@jane/shared/util';

export const useNeedsSignInForEligibility = ({
  brandSpecial,
  cartProduct,
  product,
}: {
  brandSpecial?: Pick<BrandSpecial, 'special_type' | 'rules'>;
  cartProduct?: Pick<PendingCartProduct, 'brand_special_has_segment_rules'>;
  product?: {
    applicable_brand_specials_excluded_user_segments?:
      | BrandSpecialUserSegmentIds
      | readonly number[];
    applicable_brand_specials_included_user_segments?:
      | BrandSpecialUserSegmentIds
      | readonly number[];
  };
}) => {
  const { data: janeUser } = useJaneUser();

  const needsSignInForEligibility = useMemo(() => {
    if (janeUser?.user.authenticated) {
      return false;
    }

    return brandSpecialOrProductHasSegments({
      brandSpecial,
      cartProduct,
      product,
    });
  }, [janeUser?.user.authenticated, brandSpecial, product]);

  return needsSignInForEligibility;
};
